import { useGenericRequestHandler } from '../../../handlers'

/**
 * @typedef {Object} MyLoopsStatistics
 * @property {number} affirmativePct
 * @property {number} assistivePct
 * @property {number} noResponsePct
 * @property {number} totalLoops
 */

/**
 * @typedef {Object} MyLoopsAssignment
 * @property {number} affirmativePct
 * @property {string} assignmentId
 * @property {string} assignmentName
 * @property {number} assistivePct
 * @property {string} className
 * @property {string} dateCreated
 * @property {number} listened
 * @property {number} noResponsePct
 * @property {number} totalLoops
 * @property {number} viewed
 */

/**
 * @typedef {Object} MyLoopsData
 * @property {MyLoopsAssignment[]} assignments
 * @property {Pagination} pagination
 * @property {MyLoopsStatistics} statistics
 * @property {MyLoopsStatistics} statistics30
 */

/**
 *
 * @return {{[p: string]: *, data: MyLoopsData}}
 */
export function useMyLoopsMutation() {
  return useGenericRequestHandler({
    route: `v1/a/loops`,
    method: 'POST'
  })
}
